<script>
  import * as Constants from '../Constants';
  import * as Utils from '../services/Utils';
  import { _ } from '../services/i18n';
  
  let items = [];
  let loading = false;
  let error = false;

  function fetchItems() {
    loading = true;
    Utils.fetchData(Constants.HOST_SERVICES + 'getWebsites')
        .then(response => response.json())
        .then(response => items = response.result.items)
        .catch(error => {
          error = true;
          console.error(error);
        })
        .finally(() => {
          loading = false;
        });
  }
  
  fetchItems();
</script>

<!-- HTML ----------------------------------------------------------------------->
<div id="container" class="fadeIn def_back gallery-websites">
  <h2 id="websites-title" class="titles">
    {$_('menu.sezWebsites')}
  </h2>

  {#if loading}
    <div class="lds-css">
      <div class="lds-eclipse"><div></div></div>
    </div>

  {:else if items}
    <ul class="thumbs">
      {#each items as elem}
        <li class="thumb">
          <a href="{elem.path}" target="_blank" rel="noopener noreferrer" title="{elem.link}">
            <img alt="{elem.title}" width="180px" height="180px"
                src="{Constants.OBYTE_HOST_UTIL + 'public/websites/' + elem.name + '.min.jpg'}" />
            <i class="fas fa-external-link-alt"></i>
            <p class="desc def_back">
              {elem.title}
              <span class="year">{elem.year}</span>
              <!--<i class="fab fa-3x fa- fa-type"></i>-->
              {#if elem.state}
                <span id="beta-tag" class="{elem.state.toLowerCase()}">{elem.state}</span>
              {/if}
            </p>
          </a>
        </li>
      {/each}
    </ul>

  {:else if error}
    <div class="gallery-error">
      <i class="far fa-times-circle"></i>
      {$_('errors.UNKNOWN')}
    </div>
  {/if}
</div>

<!-- STYLES ----------------------------------------------------------------------->
<style type="text/scss">
@import '../../public/styles/variables';
@import '../../public/styles/mixins';

#container {
  p.desc {
    text-align: center;
    width: 100%;
    height: 100%;
    margin: -4px 0 0;
    line-height: 30px;
    font-weight: bold;
    position: absolute;
    top: 184px;
    border-top: 1px solid $idro-palette-first;
    @include transition(all 0.2s ease-in-out);
  }
  span.year {
    display: block;
    line-height: 20px;
    font-weight: normal;
    font-size: $font-size-s;
    color: #aadada;
    text-shadow: none;
    margin-bottom: 6px;
  }
  .fa-external-link-alt {
    position: absolute;
    right: 10px;
    bottom: 10px;
    z-index: 1;
    font-size: $font-size-s;
    color: #aadada;
  }
  .fa-type {
    font-weight: normal;
    text-shadow: none;
    &.fa-drupal { color: $idro-skill-drupal }
    &.fa-angular { color: $idro-skill-angular }
    &.fa-php { color: $idro-skill-php }
    &.fa-wordpress { color: $idro-skill-wordpress }
    &.fa-spring { color: $idro-skill-spring }
    &.fa-react { color: $idro-skill-react }
    &.fa-adobe { color: $idro-skill-adobe }
  }
  ul.thumbs {
    margin: 25px auto 0;
    .thumb {
      &.drupal { border-color: $idro-skill-drupal }
      &.angular { border-color: lighten($idro-skill-angular, 10%) }
      &.php { border-color: $idro-skill-php }
      &.wordpress { border-color: $idro-skill-wordpress }
      &.spring { border-color: $idro-skill-spring }
      &.react { border-color: $idro-skill-react }
      &.adobe { border-color: $idro-skill-adobe }
      &.svelte { border-color: $idro-skill-svelte }
      margin: 14px;
      @include border-radius(10px);
      height: 235px;
      &:hover .desc {
        position: absolute;
        top: 3px;
        background-color: transparentize($idro-palette-dark-background, 0.1);
      }
      @include box-shadow(0 0 10px 0 $idro-palette-black);
      /* without hover for mobile */
      @media #{$tablet-m} {
        .desc {
          position: absolute;
          top: 136px;
          background-color: transparentize($idro-palette-dark-background, 0.1);
        }
      }
    }
  }

  #beta-tag {
    background: #055f11;
    line-height: 10px;
    padding: 2px 5px;
    color: #fff;
    font-size: 10px;
    letter-spacing: 1px;
    @include border-radius(10px);
    display: block;
    width: 45px;
    margin: 10px auto;
    &.test {
      background: #cf9117;
    }
    &.alpha {
      background: #cf9117;
    }
  }
}
</style>
